<script>
import SearchForm from '@/components/views/searchForm/SearchForm.vue'

export default {
  name: 'FitRequest',
  components: {
    SearchForm
  },
  metaInfo: {
    title: 'FIT'
  },
}
</script>
<template>
  <div>
    <search-form />
  </div>
</template>